import { render, staticRenderFns } from "./specView.vue?vue&type=template&id=4e250288&scoped=true&"
import script from "./specView.vue?vue&type=script&lang=js&"
export * from "./specView.vue?vue&type=script&lang=js&"
import style0 from "./specView.vue?vue&type=style&index=0&id=4e250288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e250288",
  null
  
)

export default component.exports